<div class="avatar-upload">
  <div class="avatar-edit">
    <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" (change)="onFileSelect($event)"/>
    <label for="imageUpload"><i class="bi bi-camera"></i></label>
  </div>
  <div class="avatar-preview">
    <img class="profile-user-img" id="imagePreview" [src]="image" alt="User profile picture">
  </div>
</div>